import { AppModule } from 'app/module';
import './styles.scss';

export class JobAlarmNoSpamText extends AppModule {
}
